import template from './selectFormElement.html';
import controller from './selectFormElement.controller';
import './selectFormElement.scss';

let selectFormElementComponent = {
  restrict: 'E',
  bindings: {
    options: '<',
    value: '=',
    label: '@',
    current: '<',
    validationError: '<'
  },
  template,
  controller
};

export default selectFormElementComponent;
